import math from './math'

const roundNumber = (num) => {
  const res = math.div(Math.round(math.mul(num, 100)), 100)
  return res;
  // return Math.ceil(num * 100) / 100;
}
/**
 * 计算税费和服务费
 * @param {number} sum - 原始金额
 * @param {Object} store - 商店配置
 * @param {number} ori_sum - 原始金额（用于某些特定计算）
 * @returns {Object} 包含各项费用和显示状态的对象
 */
export const culTaxAndServiceFee = (sum, store, ori_sum) => {
  const { serviceFeeType, taxType, taxRate, serviceFeeRate, rateType } = store;
  const baseAmount = rateType === 3 ? ori_sum : sum;

  // 初始化结果对象
  const result = {
    pd_actual_price: sum,
    pd_tax: 0,
    pd_service: 0,
    pd_tax_cls: 'hide',
    pd_service_cls: 'hide',
    totalPrice: sum,
    taxRate,
    serviceFeeRate,
    serviceFeeType,
    taxType
  };

  if (sum === 0) {
    return result;
  }

  // 计算服务费
  const calculateServiceFee = () => {
    if (serviceFeeType === 3) {
      result.pd_service_cls = '';
      result.pd_service = roundNumber(math.div(math.mul(math.mul(baseAmount, serviceFeeRate), 100), 100));
    } else if (serviceFeeType === 4) {
      result.pd_service_cls = '';
      result.pd_service = roundNumber(serviceFeeRate);
    }
  };

  // 计算税费
  const calculateTax = () => {
    if (taxType === 3 || taxType === 4) {
      result.pd_tax_cls = '';
      const taxBase = taxType === 4 ? sum : math.add(sum, result.pd_service);
      result.pd_tax = roundNumber(math.div(math.mul(math.mul(taxBase, taxRate), 100), 100));
    }
  };

  // 计算总价
  const calculateTotalPrice = () => {
    if (serviceFeeType === 3 && taxType === 2) {
      const a = math.add(1, taxRate);
      const b = math.add(1, 0);
      const c = math.mul(a, b);
      const d = math.div(baseAmount, c);
      result.pd_actual_price = math.div(math.mul(d, 100), 100);
      result.pd_service = math.div(math.mul(math.mul(result.pd_actual_price, serviceFeeRate), 100), 100);
      result.totalPrice = math.div(math.mul(math.add(result.pd_service, sum), 100), 100);
    } else {
      result.totalPrice = math.add(
        math.add(result.pd_actual_price, result.pd_service),
        result.pd_tax
      );
    }
  };

  // 执行计算
  calculateServiceFee();
  calculateTax();
  calculateTotalPrice();

  return result;
};

const toNumber = (value, fallback = 0) => {
  if (value == null || value === '') return fallback
  const num = Number(value)
  return Number.isNaN(num) ? fallback : num
}

/**
 * 是否使用 packagePrice：0 视为免费；等于 price 不改原规则。
 * packagePrice 高于 price 时仍作为成交价，但不展示优惠划线。
 */
export const shouldUsePackagePrice = (item) => {
  if (!item) return false
  if (item.packagePrice == null || item.packagePrice === '') return false
  const pkg = toNumber(item.packagePrice, NaN)
  const price = toNumber(item.price)
  if (Number.isNaN(pkg)) return false
  if (pkg === price) return false
  return true
}

export const shouldShowPackageDiscount = (item) => {
  if (!shouldUsePackagePrice(item)) return false
  const pkg = toNumber(item.packagePrice)
  // 套餐免费只展示 0，不按折扣划线/角标处理
  if (pkg === 0) return false
  return pkg < toNumber(item.price)
}

/** 权益套餐折扣百分比，如 price=100/packagePrice=80 → 20；非折扣返回 null */
export const getPackageDiscountPercent = (item) => {
  if (!shouldShowPackageDiscount(item)) return null
  const price = toNumber(item.price)
  if (price <= 0) return null
  const percent = Math.round(math.mul(math.sub(1, math.div(toNumber(item.packagePrice), price)), 100))
  if (!Number.isFinite(percent) || percent <= 0 || percent >= 100) return null
  return percent
}

export const getPriceSource = (item) => {
  if (!item) return item

  // packagePrice 是 home.do 的 products 字段，有规格时也必须优先使用产品级套餐价。
  if (shouldUsePackagePrice(item)) return item

  const specItem = item.specItem
  if (specItem && (specItem.price != null || specItem.packagePrice != null)) {
    return specItem
  }
  return item
}

export const getProductBasePrice = (item) => {
  if (shouldUsePackagePrice(item)) return toNumber(item.packagePrice)
  return toNumber(item.price)
}

export const getDisplayOriginPrice = (item) => {
  if (!item) return 0
  if (shouldShowPackageDiscount(item)) return toNumber(item.price)
  // 套餐价高于原价时不展示任何划线价。
  if (shouldUsePackagePrice(item)) return toNumber(item.packagePrice)
  if (item.orgPrice == null || item.orgPrice === '') return toNumber(item.price)
  return toNumber(item.orgPrice)
}

/** 属性行成交单价（subAttr / attrArr 项有 packagePrice 时优先用套餐价） */
export const getAttrUnitPrice = (attr) => getProductBasePrice(attr)

/** 属性行展示用原价（划线） */
export const getAttrOriginUnitPrice = (attr) => getDisplayOriginPrice(attr)

export const sumAttrArrAmount = (attrArr = []) => {
  if (!Array.isArray(attrArr) || !attrArr.length) return 0
  return attrArr.reduce(
    (sum, attr) => math.add(sum, math.mul(getAttrUnitPrice(attr), attr.quantity || 1)),
    0
  )
}

export const sumAttrArrOriginAmount = (attrArr = []) => {
  if (!Array.isArray(attrArr) || !attrArr.length) return 0
  return attrArr.reduce(
    (sum, attr) => math.add(sum, math.mul(getAttrOriginUnitPrice(attr), attr.quantity || 1)),
    0
  )
}

export const getMinAttrPrice = (attrs = []) => {
  const subAttrs = (attrs || []).flatMap(attr => attr.subAttrList || [])
  if (!subAttrs.length) return 0
  return Math.min(...subAttrs.map(getAttrUnitPrice))
}

export const getMinAttrOriginPrice = (attrs = []) => {
  const subAttrs = (attrs || []).flatMap(attr => attr.subAttrList || [])
  if (!subAttrs.length) return 0
  return Math.min(...subAttrs.map(getAttrOriginUnitPrice))
}

export const hasAttrPackagePrice = (item) => {
  if (!item) return false
  const { attrArr = [], attrs = [] } = item
  if (Array.isArray(attrArr) && attrArr.some(shouldUsePackagePrice)) return true
  const subAttrs = (attrs || []).flatMap(attr => attr.subAttrList || [])
  return subAttrs.some(shouldUsePackagePrice)
}

export const isPackagePriceFree = (item) => {
  const source = getPriceSource(item)
  return source?.packagePrice === 0 || source?.packagePrice === '0'
}

export const shouldShowAsFree = (item) => {
  if (!item) return false
  if (item.priceType === 4) return true
  return isPackagePriceFree(item)
}

export const getSubmitPrice = (item) => getProductBasePrice(getPriceSource(item))

const normalizeAttrPrices = (attrArr) => {
  if (!Array.isArray(attrArr)) return attrArr
  return attrArr.map((attr) => (
    shouldUsePackagePrice(attr)
      ? { ...attr, price: getAttrUnitPrice(attr) }
      : attr
  ))
}

export const normalizeOrderProductPrices = (data) => {
  if (!Array.isArray(data?.products)) return data
  return {
    ...data,
    products: data.products.map(product => ({
      ...product,
      // 只有套餐价生效时才改写 price，其他情况保持原有下单规则。
      price: shouldUsePackagePrice(product) ? getSubmitPrice(product) : product.price,
      attrArr: normalizeAttrPrices(product.attrArr),
    })),
  }
}

export const getPreviewValidationFlag = (products) =>
  !Array.isArray(products) || !products.some(product =>
    shouldUsePackagePrice(product) || hasAttrPackagePrice(product)
  )

export const hasActivePackagePrice = (products) =>
  Array.isArray(products) && products.some(product =>
    shouldUsePackagePrice(product) || hasAttrPackagePrice(product)
  )

export const getActivePackageName = (products) => {
  if (!Array.isArray(products)) return ''
  const hit = products.find(product => shouldUsePackagePrice(product) || hasAttrPackagePrice(product))
  if (!hit) return ''
  return hit.packageName || hit.package_name || hit.benefitPackageName || hit.packageRuleName || ''
}

export const getProductListPriceSource = (item) => {
  if (!item) return item
  if (shouldUsePackagePrice(item)) return item
  const { specs = [] } = item
  if (!specs.length) return item
  return specs.reduce((min, spec) =>
    getProductBasePrice(spec) < getProductBasePrice(min) ? spec : min
  )
}

export const getProductLineAmount = (item, withQuantity = false) => {
  const { attrArr = [], quantity = 1 } = item || {}
  if (isPackagePriceFree(item)) return 0
  const attrPrice = sumAttrArrAmount(attrArr)
  const unit = math.add(attrPrice, getProductBasePrice(getPriceSource(item)))
  return withQuantity ? math.mul(unit, quantity || 1) : unit
}

export const getProductPriceInfo = (item) => {
  if (!item) return { amount: 0, oriAmount: 0 }

  const { attrs = [], specs = [], specItem, attrArr = [] } = item
  const minAttrPrice = getMinAttrPrice(attrs)
  const minAttrOriPrice = getMinAttrOriginPrice(attrs)
  const selectedAttrPrice = sumAttrArrAmount(attrArr)
  const selectedAttrOriPrice = sumAttrArrOriginAmount(attrArr)

  if (specItem || attrArr.length > 0) {
    const source = getPriceSource(item)
    return {
      amount: isPackagePriceFree(source) ? 0 : math.add(getProductBasePrice(source), selectedAttrPrice),
      oriAmount: math.add(getDisplayOriginPrice(source), selectedAttrOriPrice)
    }
  }

  if (specs.length > 0) {
    const minSpec = getProductListPriceSource(item)
    return {
      amount: isPackagePriceFree(minSpec) ? 0 : math.add(minAttrPrice, getProductBasePrice(minSpec)),
      oriAmount: math.add(minAttrOriPrice, getDisplayOriginPrice(minSpec))
    }
  }

  return {
    amount: isPackagePriceFree(item) ? 0 : math.add(minAttrPrice, getProductBasePrice(item)),
    oriAmount: math.add(minAttrOriPrice, getDisplayOriginPrice(item))
  }
}
